export const LicenseHoldRouting = [
  {
    path: "/license-manage/license-hold/list",
    name: "license-hold-list",
    meta: { title: "持证管理" },
    component: () => import("@/views/license-manage/license-hold/list/index.vue"),
  },
  {
    hidden: true,
    path: "/license-manage/license-hold/create",
    name: "license-hold-create",
    meta: { title: "新建持证管理" },
    component: () => import("@/views/license-manage/license-hold/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/license-manage/license-hold/edit/:id",
    name: "license-hold-edit",
    meta: { title: "编辑持证管理" },
    component: () => import("@/views/license-manage/license-hold/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/license-manage/license-hold/detail/:id",
    name: "license-hold-detail",
    meta: { title: "持证管理详情" },
    component: () => import("@/views/license-manage/license-hold/form-detail/index.vue"),
  },
];
